import React from 'react';
import { Form, Radio, Icon } from '@block/plug';
import { HoverText } from '@src/components';
import Url from './url';
import { doAction } from '../../utils';
import './index.scss';

interface Props {
  ref: any;
}

interface State {
  satisfy: boolean;
}
class TaxInfo extends React.Component<Props, State> {
  formRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.state = {
      satisfy: null,
    };
    this.formRef = React.createRef();
  }

  async componentDidMount() {
    this.check();
    const data = (await doAction(Url.getInfo, {}, null)) || {};
    const workData = (await doAction(Url.getWorkInfo, {}, null)) || {};
    if (workData.isFirstJob === 1 && data.firstEntryInMidYear === null) {
      data.firstEntryInMidYear = true;
    } else if (workData.isFirstJob === 0 && data.firstEntryInMidYear === null) {
      data.firstEntryInMidYear = false;
    }
    this.formRef.current?.setAllFieldsValue?.(data);
  }

  check = async () => {
    const { satisfyFirstEntry } = (await doAction(Url.check, {}, null)) || {};
    this.setState({ satisfy: satisfyFirstEntry });
  };

  handleSave = async () => {
    const ref = this.formRef.current;
    if (ref?.validateFields()) {
      const data = await doAction(Url.save, this.handleFetchFinalData());
      return data === undefined ? false : data;
    }
    return false;
  };

  // 获取最终组织数据
  handleFetchFinalData = () => this.formRef.current.getFieldsValueIncludeHide();

  render() {
    const { ref } = this.props;
    const { satisfy } = this.state;
    return (
      <div className="tax" ref={ref}>
        <Form className="tax__form" ref={this.formRef} labelWidth="150px">
          <Form.Title>个税承诺</Form.Title>
          <Form.Item
            formItemKey="firstEntryInMidYear"
            labelInValue={false}
            span={12}
            label={
              <HoverText
                message={
                  <div className="tax__tooltip__content">
                    <span>
                      2020年7月底国家出台了一项为年内首次入职人员量身定制的
                      <a
                        href="http://www.chinatax.gov.cn/chinatax/n810341/n810755/c5154948/content.html"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        个税新政策
                      </a>
                      ，这项政策可以减轻同学们在个税预扣预缴阶段的的税负。简单来说，是通过“调高”累计个税起征点，达到“降税”的效果。
                      <br />
                      年内首次入职人员包含：
                      <ul>
                        <li>自本年度1月至今，没有在上家单位取得过收入的；</li>
                        <li>本年度自1月起待业至以正式员工身份加入美团的同学。</li>
                      </ul>
                    </span>
                  </div>
                }
                extra="："
              >
                年内首次入职
              </HoverText>
            }
            required
            message="不能为空"
          >
            <Radio.Group toFormItem>
              <Radio value>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        <div className="tax__note">
          <div>
            <Icon type="info-circle" />
            说明
          </div>
          <div>
            根据你填写的工作经历信息，你可能
            <span className="blue">{satisfy ? '满足' : '不满足'}</span>
            当年首次入职的条件。如自本年度至今，没有取得过工资或实习费等收入的，可以填写为“是”，否则填写为“否”。如无法确认，可根据以下步骤确认是否满足条件后进行选择。
            <br />
            <br />
            做出选择后，公司将根据选择以及税局的规定预扣预缴个税，如选择与实际情况不符，需要自行通过明年3月开始的汇算清缴来补缴税款或者申请退税。
            <br />
            登录个人所得税App-【首页】-【我要查询】-【收入纳税明细查询】，可以查询本人今年1月开始取得的收入、已申报税额等明细数据。
            <br />
            1.【所得项目小类】中有包括正常工资薪金/证券经纪人佣金收入/保险营销员佣金收入/其他连续劳务报酬的，不属于首次取得工资、薪金所得的人员，请选择
            “<span className="blue">否</span>” 。
            <br />
            2.【所得项目小类】中没有报税记录，或只包括一般劳务报酬/其他非连续劳务报酬/稿酬/特许权使用费的，属于首次取得工资、薪金所得的人员，请选择
            “<span className="blue">是</span>”。
          </div>
        </div>
      </div>
    );
  }
}
export default TaxInfo;
